export default {
  rounded: {
    borderRadius: 10
  },
  elevation1: {
    boxShadow: '0 1px 2px rgba(16,24,40,.06), 0 1px 3px rgba(16,24,40,.08)'
  }
};
